import axios from 'axios';

// URL de base du domaine backend (exportée pour les fichiers statiques)
export const API_BASE_URL = 'https://apifrequence974.gaelprod974.re';

// Configuration de base d'Axios
const API = axios.create({
  baseURL: `${API_BASE_URL}/api`, 
});

// Middleware pour ajouter automatiquement le Token à chaque requête
API.interceptors.request.use((config) => {
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      if (user && user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
  } catch (error) {
    console.error("Erreur lecture token localStorage", error);
  }
  return config;
});

// --- MODULE AUTHENTIFICATION ---
export const login = (credentials) => API.post('/auth/login', credentials);
export const register = (userData) => API.post('/auth/register', userData);

// --- MODULE VIDÉOS ---
export const getAllVideos = () => API.get('/videos/all');
export const createVideo = (videoData) => API.post('/videos', videoData);
export const deleteVideo = (id) => API.delete(`/videos/${id}`);
export const uploadVideo = (formData) => API.post('/videos/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// --- MODULE PARTENAIRES ---
export const getAllPartners = () => API.get('/partners');
export const createPartner = (formData) => API.post('/partners', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const deletePartner = (id) => API.delete(`/partners/${id}`);
export const updatePartner = (id, formData) => API.put(`/partners/${id}`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// --- MODULE FLASH INFO ---
export const getCurrentFlash = () => API.get('/flash-info');
export const updateFlash = (flashData) => API.post('/flash-info', flashData);
export const disableFlash = (id, userData) => API.patch(`/flash-info/disable/${id}`, userData);

// --- MODULE PROGRAMMES (GRILLE) ---
export const getAllProgrammes = () => API.get('/programmes');
export const createProgramme = (data) => API.post('/programmes', data);
export const updateProgramme = (id, data) => API.put(`/programmes/${id}`, data);
export const deleteProgramme = (id) => API.delete(`/programmes/${id}`);

// --- MODULE ARTICLES ---
export const getArticles = () => API.get('/articles');

// --- MODULE MESSAGES / CHAT & DÉDICACES ---
export const getChatHistory = () => API.get('/messages/chat');
export const sendChatMessage = (messageData) => API.post('/messages/chat', messageData);
export const deleteChatMessage = (id) => API.delete(`/messages/chat/${id}`);
export const getDedicaces = () => API.get('/messages/dedicaces');
export const sendDedicace = (msgData) => API.post('/messages/dedicace', msgData);

export default API;